import { registerPlugin } from '@capacitor/core';
const CapacitorSdc = registerPlugin('CapacitorSdc', {
    web: () => import('./web').then(m => new m.CapacitorSdcWeb()),
});
export * from './definitions';
export { CapacitorSdc };
//# sourceMappingURL=index.js.map